export default __webpack_public_path__ + "static/media/lineup-trucks.6e831114.jpg";